module.exports = __webpack_public_path__ + "img/art-10.c1c35819.png";